import React, { useEffect } from "react";

import "./reservationPage.css";
import ReservationCard from "./ReservationCard";
import ReservationStepper from "./ReservationStepper";
import { ClientContext } from "../../../store/context";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";

function ReservationPage() {
  const {
    carToReserve,
    setInsuranceChecked,
    setFormBody,
    setExtrasPicked,
    setReservationComments,
    reservationComments,
  } = React.useContext(ClientContext);
  const navigate = useNavigate();
  
  useEffect(() => {
    if(carToReserve==null){
      navigate('/')
    }
    setExtrasPicked([]);
    setInsuranceChecked({
      id: null,
      title: "",
      pricePerDay: "",
    });
    setFormBody({
      customerName: null,
      customerLastName: null,
      customerMail: null,
      customerPhone: null,
      customerAddress: null,
      customerCountry: null,
      flightNumber: null,
    });
    setReservationComments(null);
  }, []);

  return (
    <div className="reservation-page-content">
      <Box
        className="reservation-page-grid"
        sx={{
          width: { xs: "95%", md: "60%" },
          flexDirection: { xs: "column", md: "row" },
        }}
      >
        <ReservationCard />
        <div className="reservation-page-stepper">
          <ReservationStepper />
        </div>
      </Box>
    </div>
  );
}

export default ReservationPage;
